export function ActiveColorGenerator(selectedMenu:string, menuName:string) {
    if (selectedMenu === menuName){
        return "#4FD5F2"
    }else{
        return "#0F1560";
    }
}

export function ActiveDropdownColorGenerator(selectedMenu:string, menuName:string) {
    if (selectedMenu === menuName){
        return "#4FD5F2"
    }else{
        return "#0f1560";
    }
}

export function ActiveDropdownGeneratorDrawer(selectedMenu:string, menuName:string) {

    if (selectedMenu === menuName){
        return "#3143C0";
    }else{
        return  "#0F1560";
    }
}